var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"ui-btn",class:[_vm.getClasses(), {
    'ui-btn--disabled': _vm.disabled,
}],style:({'background': `${_vm.background} !important`}),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('div',{staticClass:"dynamic-background"}),_c('span',[_vm._t("default")],2),(_vm.defaultIcon && _vm.type === 'search')?_c('img',{attrs:{"src":require("@/assets/icons/next-circle.svg")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }